import React, {useEffect} from 'react';
import {useTheme} from '@material-ui/core/styles';
import {Label, Legend, Line, LineChart, ResponsiveContainer, XAxis, YAxis} from 'recharts';
import Title from '../miscellaneous/Title';
import Tooltip from "recharts/lib/component/Tooltip";
import Slider from "@material-ui/core/Slider";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {isFiltered, numberWithSpaces} from "../miscellaneous/functions";

const sliderStyles = makeStyles({
    root: {
        display: "flex",
    },
    tooltip: {
        padding : "10px",
        zIndex: 10,
        border: "1px solid lightgrey",
        backgroundColor: "white",

    },
    solver : {
        padding: "2px 10px",
        display: "flex",
        justifyContent: "space-between"


    },
    span2 : {
        marginRight : "5px",
    }
});




function valuetext(value) {
    return `${value}`;
}

function RangeSlider(props) {

    return (
        <div style={{flex: 2}}>
            <Slider
                value={props.value}
                onChange={props.handleChange}
                valueLabelDisplay="auto"
                aria-labelledby="range-slider"
                getAriaValueText={valuetext}
                step={10}
                min={0}
                max={props.max}
                marks={props.marks}
            />
        </div>
    );
}





export default function Cactus(props) {
    const theme = useTheme();
    const classes = sliderStyles();

    const [value, setValue] = React.useState([0, props.maxX]);

    const palette = [ "#3D91E0", "#952B60", "#F1B620", "#F952E1", "#BF4684", "#CBAE11", "#008D7C",  "#A8E10C", "#26DFE0", "#626520"]
    //const palette = ["#8884d8", "#d88884", "#84d8b2", "#b284d8", "#d8b284", "#d884aa", "#84d888"]
    const shapes = ["dot", "cross", "diamond", "rectangle", "polygon"]


    useEffect(() => {
        setValue([0, props.maxX])
    }, [props.maxX]);

    if (props.data.length === 0) return (
        <React.Fragment>
            <Title>Cactus Plot</Title>
        </React.Fragment>
    );

    let data = props.data

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const marks = [
        {
            value: 0,
            label: '0',
        },
        {
            value: props.maxX,
            label: props.maxX,
        },
    ];


    if (data.length === 0) return (
        <React.Fragment>
            <Title>Cactus Plot</Title>
        </React.Fragment>
    )

    function CustomTooltip(props) {
        //if(props.payload.length > 1) console.log(props)
        if (props.active === false)
            return null
        let payload  = props.payload
        payload.sort((a, b) => a.value - b.value)

        return (
            <div className={classes.tooltip}>
                {props.label} instances solved:
                {payload.map( p => <div className={classes.solver} style={{color: p.stroke}}><span className={classes.span2}>{p.name}:</span> <span>{numberWithSpaces(p.value)}s</span></div>)}
            </div>
        )
    }



    return (
        <React.Fragment>
            <Title><span style={{color:'#408033'}}>{props.title}</span></Title>
            <ResponsiveContainer>
                <LineChart data={data} margin={{top: 16, right: 16, bottom: 0, left: 24,}}>
                    <Legend/>
                    <XAxis dataKey="nb" stroke={theme.palette.text.secondary} type="number" domain={value} allowDataOverflow={true}>
                    </XAxis>
                    <YAxis stroke={theme.palette.text.secondary}>
                        <Label angle={270} position="left" style={{textAnchor: 'middle', fill: theme.palette.text.primary}}>Time (s)</Label>
                    </YAxis>
                    <Tooltip content={<CustomTooltip />}/>
                    {props.selectedSolvers.map((s, i) => <Line key={'l' + s.id} type="monotone" dataKey={s.name + " " + s.version}
                                                               stroke={palette[i % palette.length]} shape={shapes[i % shapes.length]} dot={true}/>)}
                </LineChart>
            </ResponsiveContainer>
            <div className={classes.root}>
                <div style={{flex: 1, textAlign: "right", paddingRight: "20px", paddingTop: "2px"}}>Xaxis offset:</div>
                <RangeSlider value={value} handleChange={handleChange} marks={marks} max={props.maxX}/>
            </div>
        </React.Fragment>
    );
}